import React, { FC, useEffect, useRef } from "react";
import NcModal from "components/NcModal/NcModal";
import { CommentType } from "./CommentCard";
import ButtonPrimary from "components/Button/ButtonPrimary";
import ButtonSecondary from "components/Button/ButtonSecondary";
import { deleteDoc, doc, increment, updateDoc, arrayRemove} from "firebase/firestore";
import {db} from "../../configs/firebase-config";

export interface ModalDeleteCommentProps {
  comment: any;
  show: boolean;
  onCloseModalDeleteComment: () => void;
  data?: any;
}

const ModalDeleteComment: FC<ModalDeleteCommentProps> = ({
  comment,
  show,
  onCloseModalDeleteComment,
  data
}) => {
  let commentsToDelete: any[] = [];
  const textareaRef = useRef(null);

  const getNestedComments = (rootComment: any) => {
    if (rootComment.children){
      rootComment.children.map(async (child: any) => {
        commentsToDelete.push(child);
        await getNestedComments(child);
      })
    }
  }
  const handleClickSubmitForm = async (e: any) => {
    e.preventDefault();
    let counter = 0;
    commentsToDelete = [];
    const postDocRef = doc(db, "posts", `${data.userId}/posts/${data.id}`);
    if (comment.children) {
      commentsToDelete.push(comment);
      await getNestedComments(comment);
      for (let commentToDelete of commentsToDelete){
        const commentDocRef = doc(db, "posts", `${data.userId}/posts/${data.id}/comments/${commentToDelete.docId}`);
        if (commentToDelete.parentId){
          const parentDocRef = doc(db, "posts", `${data.userId}/posts/${data.id}/comments/${commentToDelete.parentId}`);
          try {
            await updateDoc(parentDocRef, {childrens: arrayRemove(commentToDelete.docId)})
          } catch (error) {
            console.log(error);
          }
        }
        await deleteDoc(commentDocRef);
        counter++;
      }
      await updateDoc(postDocRef, {commentCount: increment(-counter), priority: increment(-5)});
    } else {
      const commentDocRef = doc(db, "posts", `${data.userId}/posts/${data.id}/comments/${comment.docId}`);
      await deleteDoc(commentDocRef);
      await updateDoc(postDocRef, {commentCount: increment(-1), priority: increment(-5)});
    }
    onCloseModalDeleteComment();
  };

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        const element: HTMLTextAreaElement | null = textareaRef.current;
        if (element) {
          (element as HTMLTextAreaElement).focus();
        }
      }, 400);
    }
  }, [show]);

  const renderContent = () => {
    return (
      <form onSubmit={async (e: any) => {await handleClickSubmitForm(e)}}>
        <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
          Delete comment
        </h3>
        <span className="text-sm">
          Are you sure you want to delete this comment? You cannot undo this
          action.
        </span>
        <div className="mt-4 space-x-3">
          <ButtonPrimary type="submit">
            Delete
          </ButtonPrimary>
          <ButtonSecondary type="button" onClick={onCloseModalDeleteComment}>
            Cancel
          </ButtonSecondary>
        </div>
      </form>
    );
  };

  const renderTrigger = () => {
    return null;
  };

  return (
    <NcModal
      isOpenProp={show}
      onCloseModal={onCloseModalDeleteComment}
      contentExtraClass="max-w-screen-sm"
      renderContent={renderContent}
      renderTrigger={renderTrigger}
      modalTitle=""
    />
  );
};

export default ModalDeleteComment;
